import * as React from "react";

export class Cta extends React.Component<{ url: string, handler: Function }, {}> {
    render() {
        return (
            <a href={this.props.url} onClick={(event) => this.props.handler(event)} className="rj-racing-future-events__cta">{this.props.children}</a>
        )
    }
}